import actions from "@/store/modules/offers/actions";
import mutations from "@/store/modules/offers/mutations";

export const INITIAL_OFFER_STATE = {
  offers: [],
  isFetchingOffers: false,
  currentOffer: null,
  isFetchingCurrentOffer: false,
  isFetchingOfferComments: false,
  offerComments: [],
  isFetchingMailto: false,
  isFetchingOfferGroupDocument: false,
  offerGroupDocument: null,
  offerGroupDocumentComments: [],
  isFetchingOfferGroupDocumentComments: false,
  isAddingFileToOfferGroup: false,
  currentOfferGroups: [],
  isFetchingCurrentOfferGroups: false,
  isFetchingOfferGroupTemplates: false,
  offerGroupTemplates: [],
  isAddingOfferGroup: false,
  isFetchingCurrentContract: false,
  currentContract: null
};

export default {
  namespaced: true,
  state: { ...INITIAL_OFFER_STATE },
  actions,
  mutations
};
